(function() {
  'use strict';
  /**
   * @ngdoc overview
   * @name oblique-features
   * @description
   * The `oblique-features` angular module is the main module for loading the
   * feature enable/disable/hide functionality of oblique-features.
   */
  angular.module('oblique-features', []);
})();
